import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import axios from 'axios';



Vue.use(Router)
/* eslint-disable no-new */
// const router = new VueRouter({
//   mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
//   routes: routes
// })
const router = new Router({
    routes,
    mode: 'history'
})

let baseURL = '',baseURL2 = '', WWWUrl = "";
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://apis.aigupiao.com'
    WWWUrl = 'https://mobile.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://apisdev.aigupiao.com'
    WWWUrl = 'https://mobiledev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://apisbeta.aigupiao.com'
    WWWUrl = 'https://mobilebeta.aigupiao.com';
}

router.beforeEach((to, from, next) => {
    console.log(to,'tooooooooooooooo');
    if (!to.matched.length) {
        location.replace('/error.html#/404')
        return
    }
    /* else if(to.matched[0].path == "/ucenter/index" || to.matched[0].path == "/ucenter/index/") {
        if(location.origin.indexOf("jfinfo") == -1 && process.env.NODE_ENV !== 'development') {
            let _href = location.origin.replace('aigupiao.com','jfinfo.com')
            _href = _href.replace('mobile','igp');
            _href += location.pathname
            location.replace(_href)
        }
                
        next()
    } */
    else if(to.matched[0].path == "/lives/center/id/:id" || to.matched[0].path == "/lives/center/id/:id/*"){
        //老师用户
        var id = to.params.id;
        // 判断这个l_id 是否被注销
        axios({
            url: WWWUrl + '/H5ReactLives/get_live_detail/',
            method: 'post',
            params: {l_id : id,}
        }).then( ( res ) => {
            // 失败挑战主页面
            if(res.data.code == "111111"){
                alert("该用户已被注销，页面将跳转至首页");
                location.replace('https://mobile.aigupiao.com/index?jump#tab0');
            }else{
                if(res.data.data.serve_vip == 'yes') {
                    //正式环境
                    if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao.com')>-1 && false){
                        location.replace(location.href.replace('aigupiao.com','aigupiao8.com'))
                    } else if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1) {
                        location.replace(location.href.replace('aigupiao8.com','aigupiao.com'))
                    } else if(process.env.NODE_ENV !== 'development' && res.data.data.company == 'jf') {
                        if(location.origin.indexOf("jfinfo") == -1) {
                            let _href = location.origin.replace('aigupiao.com','jfinfo.com')
                            _href = _href.replace('mobile','igp');
                            _href += location.pathname
                            location.replace(_href)
                        }
                    }
                } else {
                    //正式环境
                    if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1){
                        location.replace(location.href.replace('aigupiao8.com','aigupiao.com'))
                    }
                }
                
                next()
            }
        }).catch((err) => {  

        });
    }
    else if(to.matched[0].path == "/ucenter/user_home/m_u_id/:id"){

        var id = to.params.id;
        axios({
            url: baseURL2 + '/UserCenter/get_user_info',
            method: "get",
            params: {
                u_id: id
            }
        }).then(res=>{
            console.info(res, "RES_______!!!!!!!")
            if(res && res.data && res.data.info && res.data.info.l_id > 0) {
                location.replace('/lives/center/id/' + res.data.info.l_id);
            } else {
                //非老师用户
                if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1){
                    location.replace(location.href.replace('aigupiao8.com','aigupiao.com'))
                }
                next()
            }
        })
    }
    else if(to.matched[0].path == "/up/HsReplicaProfits") {
        if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1){
            location.replace(location.href.replace('aigupiao8.com','aigupiao.com'))
        }
        next()
    }
    else if(to.matched[0].path.includes("/up/app/") && to.matched[0].name == '爱股票-会员产品'){
        //正式环境
        // if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao.com')>-1){
        //     location.replace(location.href.replace('aigupiao.com','aigupiao8.com'))
        // }
        //支付相关页面 需要先登录
        console.log('hasGetInfo',store.state.user.hasGetInfo)
        if (!store.state.user.hasGetInfo ) {
            store.dispatch('getUserInfo').then(user => {
                //能获取到用户信息 可以跳转路由
                console.log('>>>',user)
                next()
                
            }).catch(() => {
                console.log('>>>1')
                function getQueryVariable(variable) {
                    var query = window.location.search.substring(1);
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        if (pair[0] == variable) { return pair[1]; }
                    }
                    return (false);
                }
                let l_id = getQueryVariable('l_id')
                //未登录直接微信登录
                location.href = `/login/wx_login.html?login_type=server_promotion_wx_login&l_id=${l_id}`;
            })
            //console.log('hasGetInfo2 ??? next')
        }

    }
    else if(to.matched[0].path.includes("/up/app/")){
        //不参与域名跳转规则，app直接用aigupiao8域名
        document.title = to.name;
        next()
    }
    else{
        //需求：  除资讯 研报 行情之外都转aigupiao8
        //新加：  除了app内嵌跟活动页面的（接口会报错） ---> (路径是/up/)   ，其他的都转为 aigupiao8
        if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao.com')>-1 && location.href.indexOf('/up/') == -1){
            // location.replace(location.href.replace('aigupiao.com','aigupiao8.com'))
        }
        if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1 && location.href.indexOf('/up/') == -1 && location.pathname == '/home'){
            location.replace(location.href.replace('aigupiao8.com','aigupiao.com'))
        }
        // 
        next()
    }
    //之前是投顾的个人主页 放在aigupiao8下 , 其他在aigupiao
    // else if(to.matched[0].path == "/app_lives/center/id/:id" || to.matched[0].path == '/app_lives/center/id/:id/*' || to.matched[0].path == '/app_ucenter/user_home/m_u_id/:id') {
    //   if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao.com')>-1){
    //     location.replace(`https://${baseURL}.aigupiao8.com${to.path}`)
    //   }
    //     next();
    // }
    // else{
    //     if(process.env.NODE_ENV !== 'development' && location.hostname.indexOf('aigupiao8.com')>-1){
    //         location.replace(`https://${baseURL}.aigupiao.com${to.path}`)
    //     }
    //     next()
    // }
    //console.log(to.matched[0])
    //路由中设置的needLogin字段就在to当中 
    if (!store.state.user.hasGetInfo && !(to.matched[0].path.includes("/up/app/"))) {
        console.log('???')
        store.dispatch('getUserInfo').then(user => {
            // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
            // turnTo(to, user.access, next)
        }).catch(() => {
            // setToken('')
            // next({
            //   name: 'login'
            // })
        })
    }

    //next()
})

router.afterEach(to => {
    // setTitle(to, router.app)
    // window.scrollTo(0, 0)
})



export default router